module.exports = __webpack_public_path__ + "img/iconfinder_Notebook_by_Artdesigner_60879.759c605e.png";